<template>
  <div class="xlisupportunit-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加支持单位</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.current"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createAd('adValidate')"
      :loading="loading"
    >
      <Form :model="supportunit" ref="adValidate" :rules="adValidate" action="javascript:void(0)">
        <FormItem label="标题" prop="title">
          <Input v-model="supportunit.title" placeholder="输入标题..."></Input>
        </FormItem>
        <FormItem label="缩略图">
          <upload-thumb
            v-model="supportunit.thumb"
            ref="uploadthumb"
            :defaultList="thumblist"
            :autoCropWidth="90" :autoCropHeight="90"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:90*90,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="链接">
          <Input v-model="supportunit.link" placeholder="输入外链..."></Input>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="supportunit.sort" placeholder="输入顺序..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
  name: "xlisupportunit-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      columns1: [
        {
          title: "排序",
          key: "sort",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "Id",
          key: "id",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "名称",
          key: "title",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "封面图",
          key: "thumb",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h("Avatar", {
                style: {
                  marginRight: "5px",
                  display: params.row.thumb ? "inline-block" : "none"
                },
                props: {
                  src: this.$publicData.ossUrl+params.row.thumb,
                  shape: "square",
                  size: "large"
                }
              })
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      title: "添加支持单位",
      tablelist: [],
      thumblist: [],
      supportunit: {
        thumb: "",
        sort: 0
      },
      showModalStatus: false,
      adValidate: {
        title: [
          { required: true, message: "支持单位名称必须填写", trigger: "blur" }
        ]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  methods: {
    getTableList: function() {
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.xlisupportunit.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage() {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 展开添加
    showModel() {
      this.title = "添加支持单位";
      this.$refs["adValidate"].resetFields();
      this.thumblist = new Array();
      this.adid = 0;
      this.supportunit = {
        thumb: "",
        title: "",
        link: "",
        sort: 0
      };
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function(index) {
      this.title = "修改支持单位";
      this.adid = index;
      this.thumblist = new Array();
      this.$refs["adValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      // 取信息
      this.$api.xlisupportunit.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.supportunit = res.result;
          if (this.supportunit.thumb) {
            this.thumblist.push({
              name: this.supportunit.thumb,
              url: this.supportunit.thumb,
              status: "finished"
            });
          }
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加
    createAd(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.supportunit.thumb = this.$refs[
              "uploadthumb"
            ].uploadList[0].url;
          }
          if (this.adid == null || this.adid == 0) {
            this.$api.xlisupportunit
              .create({ data: this.supportunit })
              .then(res => {
                if (res.code == 200) {
                  this.getTableList();
                }
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.showModalStatus = !this.showModalStatus;
              });
          } else {
            this.supportunit.id = this.adid;
            this.$api.xlisupportunit
              .edit({ data: this.supportunit })
              .then(res => {
                if (res.code == 200) {
                  this.getTableList();
                }
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.showModalStatus = !this.showModalStatus;
              });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.xlisupportunit.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    renderTable: function(name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      this.dataloading = true;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.xlisupportunit.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>
